import { UsersListBody } from "modules/users/schemas/usersModelSchemas";

const templatesListTransform = (data: UsersListBody) =>
  data.map((user) => ({
    ...user,
    actions: ["write"],
  }));

export default templatesListTransform;
